/* eslint-disable array-callback-return */
import { Grid, makeStyles, createStyles, Theme } from "@material-ui/core";
import largeImg from "../../../images/placeholder/large_img.png";
import tinyImg from "../../../images/placeholder/tiny_img.png";
import { ImageLightBox } from "../../components/ImageLightBox/ImageLightBox";
import React from "react";
import { Stack, Typography } from "@mui/material";
import { CameraAltOutlined } from "@mui/icons-material";
import { AccessibleImageLightBox } from "../../components/ImageLightBox/AccessibleImageLightBox";


export function AnnounceImageList(props: {
    photos: any;
    setShowToogleButtons?: any;
}) {
    const classes = useStyles();
    const [openImageLightBox, setOpenImageLightbox] = React.useState(false);
    const [photoIndex, setPhotoIndex] = React.useState<number>(0);

    // Log props.photos for debugging
    //console.log("Photos received in AnnounceImageList:", props.photos);

    const imageList = props.photos.map((photo: any) => photo.fileURL);

    const handleOpenImageLightBox = (index: number) => {
        setPhotoIndex(index);
        setOpenImageLightbox(true);
        props.setShowToogleButtons(false);
    };

    const handleCloseImageLightBox = () => {
        setOpenImageLightbox(false);
        props.setShowToogleButtons(true);
    };

    const maxSteps = props?.photos?.length ?? 0;

    //console.log(props.photos);
    return (
        <div className={classes.imgContent}>
            <Grid container spacing={1} className={classes.myContainer}>
                {props.photos.length >= 1 ? (
                    <>
                        <Grid
                            item
                            lg={6}
                            md={6}
                            sm={12}
                            xs={12}
                            container
                            alignItems="center"
                            
                        >
                            <div className={classes.imgLargeContainer}>
                                <img
                                    src={props.photos[0].fileURL}
                                    alt={props.photos[0].filename}
                                    className={classes.imgLarge}
                                    onClick={() => handleOpenImageLightBox(0)}
                                />
                                <Stack
                                    className={classes.previewCountContainer}
                                    direction="row-reverse"
                                    padding={1}
                                    left={5}
                                    bottom={16}
                                >
                                    <CameraAltOutlined
                                        sx={{
                                            width: 15,
                                            height: 15,
                                            color: "#fff",
                                            marginRight: 1,
                                        }}
                                    />
                                    <Typography className={classes.nombre}>
                                        {maxSteps}
                                    </Typography>
                                </Stack>
                            </div>
                        </Grid>
                        <Grid
                            item
                            lg={3}
                            md={3}
                            sm={6}
                            xs={6}
                            container
                            direction="column"
                            justifyContent="space-between"
                            alignItems="center"
                            className={classes.smallImage}
                                                     
                        >
                            {props.photos.map((photo: any, index: any) => {
                                if (index > 0 && index < 3) {
                                    return (
                                        <img
                                            src={photo.fileURL}
                                            alt={photo.filename}
                                            className={classes.imgTiny}
                                            onClick={() =>
                                                handleOpenImageLightBox(index)
                                            }
                                            key={index}
                                        />
                                    );
                                }
                            })}
                        </Grid>
                        <Grid
                            item
                            lg={3}
                            md={3}
                            sm={6}
                            xs={6}
                            container
                            direction="column"
                            justifyContent="space-between"
                            alignItems="center"
                            className={classes.smallImage}
                        >
                            {props.photos.map((photo: any, index: any) => {
                                if (index > 2 && index < 5) {
                                    return (
                                        <img
                                            src={photo.fileURL}
                                            alt={photo.filename}
                                            className={classes.imgTiny}
                                            onClick={() =>
                                                handleOpenImageLightBox(index)
                                            }
                                            key={index}
                                        />
                                    );
                                }
                            })}
                        </Grid>
                        {/* Mobile Thumbnails Row */}                        
                        <Grid
                            item
                            xs={12}
                            className={classes.mobileThumbnails}
                        >
                            <div className={classes.thumbnailRow}>
                                {props.photos
                                    .slice(1, 5)
                                    .map((photo: any, idx: number) => (
                                        <img
                                            src={photo.fileURL}
                                            alt={photo.filename}
                                            className={classes.imgMobileThumbnail}
                                            onClick={() => 
                                                handleOpenImageLightBox(idx + 1)
                                            }
                                            key={idx}
                                        />
                                    ))}
                            </div>
                        </Grid>
                    </>
                ) : (
                    <>
                        <Grid
                            item
                            lg={6}
                            md={6}
                            sm={12}
                            xs={12}
                            container
                            alignItems="center"
                        >
                            <img
                                src={largeImg}
                                alt=""
                                className={classes.imgLarge}
                            />
                        </Grid>

                        <Grid
                            item
                            lg={3}
                            md={3}
                            sm={6}
                            xs={6}
                            container
                            direction="column"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <img
                                src={tinyImg}
                                alt=""
                                className={classes.imgTiny}
                            />
                            <img
                                src={tinyImg}
                                alt=""
                                className={classes.imgTinyMobile}
                            />
                        </Grid>

                        <Grid
                            item
                            lg={3}
                            md={3}
                            sm={6}
                            xs={6}
                            container
                            direction="column"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <img
                                src={tinyImg}
                                alt=""
                                className={classes.imgTiny}
                            />
                            <img
                                src={tinyImg}
                                alt=""
                                className={classes.imgTinyMobile}
                            />
                        </Grid>
                    </>
                )}
            </Grid>
            <AccessibleImageLightBox
                isOpen={openImageLightBox}
                handleClose={handleCloseImageLightBox}
                images={imageList}
                photoIndex={photoIndex}
                setPhotoIndex={setPhotoIndex}
            />
        </div>
    );
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        imgLarge: {
            cursor: "pointer",
            height: 400,
            borderRadius: "10px"
        },
        imgTiny: {
            cursor: "pointer",
            height: 196,
            borderRadius: "10px",
            [theme.breakpoints.down("sm")]: {
                marginBottom: 8,
            },
        },
        smallImage: {
            [theme.breakpoints.down("xs")]: {
                display: "none",
            },
        },
        imgTinyMobile: {
            cursor: "pointer",
            height: 196,
            borderRadius: "10px"
        },

        radiusLeft: {
            borderTopLeftRadius: 10,
            borderBottomLeftRadius: 10,
        },
        radiusTopRight: {
            borderTopRightRadius: 10,
        },
        radiusBottomRight: {
            borderBottomRightRadius: 10,
        },
        radiusRight: {
            borderTopRightRadius: 10,
            borderBottomRightRadius: 10,
        },
        myContainer: {
            "& img": {
                width: "100%",
                objectFit: "cover",
                maxHeight: 400,
                borderRadius: "10px",
                [theme.breakpoints.down("sm")]: {
                    maxHeight: 260,
                    borderRadius: "10px"
                },
            },
        },
        imgLargeContainer: {
            width: "100%",
            position: "relative"
        },
        imgContent: {
            maxHeight: "400px !important",
            display: "contents",
        },
        previewCountContainer: {
            borderRadius: 8,
            position: "absolute",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(0,0,0,0.3)",
            color: "#fff",
            bottom: "8px !important",
        },
        nombre: {
            marginBottom: 40,
            fontSize: 10,
        },
        mobileThumbnails: {
            display: "none",
            [theme.breakpoints.down("xs")]: {
                display: "block",
                width: '100%',
                marginTop: theme.spacing(2),
                padding: '0 !important', // Remove all padding
            },
        },       
        thumbnailRow: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            gap: theme.spacing(1),
            width: '100%', // Ensure full width
            overflow: 'hidden', // Prevent scrolling
        },
        imgMobileThumbnail: {
            width: '90px !important', // Force exact width
            height: '90px !important', // Force exact height
            borderRadius: '8px',
            objectFit: 'cover',
            cursor: 'pointer',
            flexShrink: 0,
        },
    })
);
